export default {
  width: 21,
  height: 21,
  stroke: true,
  svg: `
  <g fill="none">
    <path d="M9.84375 19.0312H1.96875C1.62065 19.0312 1.28681 18.893 1.04067 18.6468C0.794531 18.4007 0.65625 18.0668 0.65625 17.7188V1.96875C0.65625 1.62065 0.794531 1.28681 1.04067 1.04067C1.28681 0.794531 1.62065 0.65625 1.96875 0.65625H15.0938C15.4418 0.65625 15.7757 0.794531 16.0218 1.04067C16.268 1.28681 16.4062 1.62065 16.4062 1.96875V7.21875" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16.4062 15.0938C18.5809 15.0938 20.3438 13.3309 20.3438 11.1562C20.3438 8.98163 18.5809 7.21875 16.4062 7.21875C14.2316 7.21875 12.4688 8.98163 12.4688 11.1562C12.4688 13.3309 14.2316 15.0938 16.4062 15.0938Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M19.0312 14.0911V20.3438L16.4062 19.0313L13.7812 20.3438V14.0911" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.59375 5.90625H11.1562" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.59375 9.84375H8.53125" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.59375 13.7812H8.53125" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </g>`
}
